import api from '../api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiRouteEnum } from '../../enums/ApiRouteEnum';

export const useDeleteOffers = (
  successCallBack: (data: any) => void,
  errorCallBack: (error: any) => void,
) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: any[]) =>
      api.delete(ApiRouteEnum.DELETE_OFFERS, { data: {
        offerIds: payload
      } }),
    {
      onSuccess: async (data) => {
        await queryClient.invalidateQueries({ queryKey: [ApiRouteEnum.OFFERS] });
        return successCallBack(data.data);
      },
      onError: (error) => {
        errorCallBack(error);
      },
    }
  );
};